import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import FolderForm from '../components/folder-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import ButtonLink from '../components/button-link';
import PageHeader from '../components/page-header';
import './page.css';

const FolderPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} un dossier`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/dossiers"
            theme="danger"
          />

          {id &&
            <ButtonLink
              className="page_action-button"
              icon="remove_red_eye"
              label="Voir en ligne"
              href={`${process.env.REACT_APP_API_HOST}/dossier/${id}`}
              theme="info"
              target="_blank"
            />
          }

        </div>

        <FolderForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default FolderPage;
